import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import { Provider } from 'react-redux';
import { store } from './app/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Auth0Provider
			domain="dev-jhy2ogcsoivhdy5w.us.auth0.com"
			clientId="dFnrjDEnLOz66HxL2CHA56JiVTLWwPoD"
			authorizationParams={{
				redirect_uri: window.location.origin
			}}
		>
			<App />
		</Auth0Provider>
	</React.StrictMode>
);